import DateRangePicker from 'react-bootstrap-daterangepicker';
import cls from './ListTaskDatePicker.module.css';
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { formatDate } from '../../../../shared/helpers';
import { Moment } from 'moment/moment';
import { tasksInformationActions } from '../../model/slice/tasksInformation';
import { Task } from '../../model/types/tasks';
import { updateCustomTask } from '../../api';
import { dateLocale } from 'shared/model/dateLocale';

interface DateRangePickerProps {
    startDate: Moment | string;
    endDate: Moment | string;
    element: {
        val: (value?: string) => void;
    };
}

export const ListTaskDatePicker = ({
    taskId,
    children,
    onShow,
    onHide,
}: {
    taskId: string;
    children: React.ReactNode;
    onShow?: () => void;
    onHide?: () => void;
}) => {
    const [inputValue, setInputValue] = useState('');
    const dispatch = useAppDispatch();
    const taskData: Task = useAppSelector((state) => state.tasksReducer.entities[taskId]);
    const tasksInformationData = useAppSelector((state) => state.tasksInformationReducer);

    const initialSettings = {
        autoUpdateInput: false,
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true,
        locale: dateLocale,
    };

    const inputProps = {
        defaultValue: '',
    };

    // необходимый костылек, чтобы дать время на обработку onApply
    const handleHide = () => {
        setTimeout(() => {
            if (onHide) onHide();
        }, 200);
    };

    const handleApply = async (
        event: React.SyntheticEvent | unknown,
        picker: DateRangePickerProps
    ) => {
        // console.log('Apply handle!');
        const formattedDate = formatDate(picker.startDate, 'DD.MM.YYYY');
        picker.element.val(formattedDate);
        setInputValue(formattedDate);

        const {
            completed,
            title,
            description,
            date_start,
            date_end,
            context,
            involved,
            estimate_id,
            project_id,
            attachments,
        } = taskData;
        const tagsFormattedToEditStore = tasksInformationData.tags
            .map((tag) => (taskData?.context?.tags?.includes(tag.id) ? tag.title : null))
            .filter(Boolean);
        const taskDataToSend = {
            taskUid: taskId,
            isCompleted: completed,
            title,
            description,
            dateStart: date_start,
            dateEnd: date_end,
            // tags: context.tags,
            color: context.color,
            status: context.status,
            entityUid: context.entity_uid,
            estimateId: estimate_id,
            projectId: project_id,
            executorId: involved.executor_id,
            observerIds: involved.observer_ids,
            isLoading: false,
            error: '',
            context: { ...taskData?.context, tags: tagsFormattedToEditStore },
            tags: tagsFormattedToEditStore,
            attachments,
        };

        const res = await dispatch(
            updateCustomTask({ ...taskDataToSend, dateEnd: formattedDate })
        ).unwrap();
        // console.log('res в отправке даты: ', res);
        dispatch(tasksInformationActions.updateTabs(res.newTabs));
    };

    return (
        <div className={cls.taskListCalendar}>
            <DateRangePicker
                initialSettings={initialSettings}
                onApply={handleApply}
                onShow={onShow}
                onHide={handleHide}
                onCancel={() => console.log('on Cancel')}
                {...(inputProps as any)} // костыль, чтобы не ругался TS
            >
                {children}
            </DateRangePicker>
        </div>
    );
};
